/*
 *	Service to interact with the backend API for fetching and updating addresses.
 *	Provides functions to get addresses, create new addresses, update existing addresses, and delete addresses.
 */

import { AddressData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';
export const addressesApi = apiResource<AddressData>('addresses');
